import { find } from "lodash-es";

import menus from "@/layouts/menu/menu";
import menuInternal from "@/layouts/menu/menuInternal";
import { getFilteredMenu } from "@/plugins/helpers/__ts/ui/hooks/ui.filteredMenu.hook";

export function getBaseURLDashboard(context: Record<string, any>): string {
  let baseURLDashboard = "";

  (function handleBaseURLDashboard(): void {
    // isInternalDashboard
    // dynamic choosing from first selected menu
    // choose menu based on dashboard
    let menuList: Array<Record<string, any>> = [];
    if (process.env.NODE_ENV === "internal") {
      menuList = menuInternal;
    } else {
      // logged in
      if (context.app.store.getters["auth/getUserData"]) {
        menuList = getFilteredMenu(context, menus);
      } else {
        // not logged in
        menuList = menus;
      }
    }

    // --- set redirect url
    const hasMainDashboard = find(
      menuList,
      (menuItem) => menuItem.isMainDashboard === true,
    );
    let selectedMenu: Record<string, any> | null = null;
    // if has isMainDashboard
    if (typeof hasMainDashboard !== "undefined") {
      selectedMenu = hasMainDashboard;
    } else {
      // doesn't have isMainDashboard --> use first array
      // eslint-disable-next-line prefer-destructuring
      selectedMenu = menuList[0];
    }
    // if has sub menu
    if (
      selectedMenu &&
      typeof selectedMenu.items !== "undefined" &&
      selectedMenu.items !== null &&
      selectedMenu.items.length
    ) {
      baseURLDashboard = context.app.localePath(
        `/${selectedMenu.name}/${selectedMenu.items[0].name}`,
      );
    } else if (selectedMenu) {
      baseURLDashboard = context.app.localePath(`/${selectedMenu.name}`);
    }
  })();

  return baseURLDashboard;
}
